<div
  class="organization"
  (click)="navigate()"
  [title]="('open' | t) + ' ' + organization.organization_name"
>
  <div class="organization__title d-flex align-items-center p-3">
    <div class="ml-2 pl-1 organization__content-wrapper">
      <div class="d-flex organization__title-wrapper">
        <div class="d-flex align-items-center">
          <img
            class="organization__image"
            src="assets/images/event_logo_default_white.svg"
          />
          <h4 class="organization__title-text">
            {{ organization.organization_name }}
          </h4>
        </div>
      </div>
      <p class="organization__subtext">{{ organization.event_count }} events</p>
      <div class="organization__events-badge-wrapper">
        <div class="organization__events-badge">
          <div class="pt-1 pb-1 pr-1 mr-2">
            <app-category-badge color="transparent" (click)="navigate()">
              Show events
            </app-category-badge>
          </div>
        </div>
        <div class="organization__follow pt-1 pb-1 pr-1 mr-2">
          <app-follow-checkbox
            (click)="$event.stopPropagation()"
            [entityName]="organization.organization_name"
            [fc]="followControl"
          ></app-follow-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #unauthorizedUserPopup>
  <app-unauthorized-user-popup
    [title]="'follow_organization' | t"
    [helpText]="'follow_organization_help_text' | t"
  ></app-unauthorized-user-popup>
</ng-template>
